import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import { StyledTableRow, StyledTableCell } from "../../../MaterialTheme/themes";
import { IRecord, IRowProps, PopupType } from "../../../Models/Entities";
import { popupState, updatedRecord } from "../../../Store/atoms";
import EditRowPopup from "../../Utilities";

interface ITableRowProps extends IRecord {
  locked?: boolean;
}

const chooseStyle = (edited: boolean, deleted: boolean) => {
  if (deleted) {
    return { color: "#CC2936", textDecoration: "line-through" };
  }

  if (edited) {
    return { backgroundColor: "#6EA4BF" };
  }

  return {};
};

export default ({
  id,
  customer_value,
  omnium_value,
  en_value,
  de_value,
  fr_value,
  it_value,
  de_abbr,
  en_abbr,
  fr_abbr,
  it_abbr,
  master,
  order,
  type_id,
  type_name,
  edited,
  deleted,
  locked = false,
}: ITableRowProps) => {
  const setUpdatedRecord = useSetRecoilState(updatedRecord);
  const setPopup = useSetRecoilState(popupState);

  const handleClick = (e: any) => {
    if (locked) {
      return;
    }
    setUpdatedRecord({
      id: id,
      customer_value: customer_value,
      omnium_value: omnium_value,
      de_value: de_value,
      en_value: en_value,
      fr_value: fr_value,
      it_value: it_value,
      de_abbr: de_abbr,
      en_abbr: en_abbr,
      fr_abbr: fr_abbr,
      it_abbr: it_abbr,
      master: master,
      order: order,
      type_id: type_id,
      type_name: type_name,
      edited: edited,
      deleted: deleted,
    });

    setPopup({
      type: PopupType.ChooseAction,
      props: { offsetX: e.clientX, offsetY: e.clientY },
    });
  };

  return (
    <StyledTableRow onClick={handleClick}>
      <StyledTableCell
        style={chooseStyle(edited, deleted)}
        component="th"
        scope="row"
      >
        {omnium_value}
      </StyledTableCell>
      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {customer_value}
      </StyledTableCell>
      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {de_value}
      </StyledTableCell>
      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {en_value}
      </StyledTableCell>
      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {fr_value}
      </StyledTableCell>
      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {it_value}
      </StyledTableCell>

      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {order}
      </StyledTableCell>
      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {master}
      </StyledTableCell>

      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {de_abbr}
      </StyledTableCell>
      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {en_abbr}
      </StyledTableCell>
      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {fr_abbr}
      </StyledTableCell>
      <StyledTableCell style={chooseStyle(edited, deleted)}>
        {it_abbr}
      </StyledTableCell>
    </StyledTableRow>
  );
};
